import PeriodValueFormulaNode from "./PeriodValueFormulaNode.js";

/**
 * `openingBalanceFormulaNode` is a concrete implementation of `periodValueFormulaNode`
 * representing an opening balance node.
 */

/**
 * TODO: write documentation
 */
export default class OpeningBalanceFormulaNode extends PeriodValueFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitOpeningBalanceNode(this, additionalInformation);
	}

	static getType() {
		return "OpeningBalanceNode";
	}

	static build(builder, additionalInformation) {
		return builder.buildPeriodValueNode(this, additionalInformation);
	}
}
